import { useMemo } from 'react';
import {
  DemoAlarmSituation,
  DemoAlarmSituationAlarm,
} from '@hakimo-ui/hakimo/types';
import { PicksBySituation } from './AlarmsPicker';

export function usePickedAlarms(
  selectedSituations: DemoAlarmSituation[],
  picksBySituation: PicksBySituation
) {
  return useMemo(() => {
    const ids = new Set<string>();
    const alarms: DemoAlarmSituationAlarm[] = [];
    selectedSituations.forEach((s) => {
      const picks = picksBySituation[s.situation];
      if (!picks) return;
      const pickSet = new Set(picks);
      s.alarms.forEach((a) => {
        if (pickSet.has(a.oldRawAlarmId)) {
          ids.add(a.oldRawAlarmId);
          alarms.push(a);
        }
      });
    });
    return { pickedAlarms: alarms, allPickedAlarmIds: ids };
  }, [selectedSituations, picksBySituation]);
}
